import styled from "styled-components";

export const FormGroupWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  margin-top: 3rem;
`;
